import { FeatureKey } from '@core/feature-preview/types/feature-key';

export const disableFeature = (key: FeatureKey): void =>
  localStorage.removeItem(key);
